import { useState } from "react";
import { useTranslation } from "react-i18next";
import DatePickerComponent from "../Field/DatePickerComponent";

const TaskFilterComponent = ({request, sendFilterTaskDataFromChild}) => {
    const { t } = useTranslation();
    const [showFilter, setShowFilter] = useState(false);
    const [filterTab, setFilterTab] = useState("name")
    const [filterInputs, setFilterInputs] = useState({
        fromDate: "",
        statusName: "",
        taskName: "",
        toDate: ""
    });

    const handleShowFilter = (e) => {
        e.preventDefault();
        setShowFilter(!showFilter);
    };
    const handleChange = (e) => {
        setFilterInputs({
            ...filterInputs,
            [e.target.name] : e.target.value
        });
    };
    const handleFromDateDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            ["fromDate"] : data
        });
    };
    const handleToDateDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            ["toDate"] : data
        });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setShowFilter(!showFilter);

        request.fromDate = filterInputs.fromDate;
        request.statusName = filterInputs.statusName;
        request.taskName = filterInputs.taskName;
        request.toDate = filterInputs.toDate;
        request.paging_offset = 1;
        sendFilterTaskDataFromChild(request);
    };
    const clearFilterData = (e) => {
        e.preventDefault();
        setShowFilter(!showFilter);
        setFilterInputs({
            ...filterInputs,
            fromDate: "",
            statusName: "",
            taskName: "",
            toDate: ""
        });
    };

    return (
        <div className="relative">
            <div className="flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3.5 sm:px-3" onClick={(e) => handleShowFilter(e)}>
                <img  src="../../../assets/icons/table/filter.svg" alt="filter" />
                <div className="hidden sm:block ml-2 text-blue-normal font-semibold text-sm capitalize">{ t('filter')}</div>
            </div>
            {
                showFilter
                ?
                    <div className="z-20 py-2 sm:py-3 bg-white top-8 absolute right-0 border border-white shadow-md rounded-[10px] w-72">
                        <div className="flex justify-between px-2 sm:px-4 ">
                            <h1 className="font-medium lg:text-lg capitalize">{ t('filter options')}</h1>
                            <div onClick={(e) => setShowFilter(!showFilter)} className="bg-black-100 flex items-center p-2 rounded-lg cursor-pointer">
                                <img src="../../assets/icons/profile/cancel.svg" alt="cancel" />
                            </div>
                        </div>
                        <div className="mt-2 border-t border-background-normal"></div>
                        <form onSubmit={(e) => handleFilterSubmit(e)}>
                            <div className="space-y-2">
                                <div className="grid grid-cols-3 gap-2">
                                    <ul>
                                        <li className={(filterTab === "task" ? "bg-light-100 text-purple-dark" : "bg-gray-dark3") + " p-2 capitalize cursor-pointer text-xs sm:text-sm"} onClick={(e) => setFilterTab("task")}>task name</li> 
                                        <li className={(filterTab === "status" ? "bg-light-100 text-purple-dark" : "bg-gray-dark3") + " p-2 capitalize cursor-pointer text-xs sm:text-sm"} onClick={(e) => setFilterTab("status")}>status</li> 
                                        <li className={(filterTab === "from-date" ? "bg-light-100 text-purple-dark" : "bg-gray-dark3") + " p-2 capitalize cursor-pointer text-xs sm:text-sm"} onClick={(e) => setFilterTab("from-date")}>from date</li> 
                                        <li className={(filterTab === "to-date" ? "bg-light-100 text-purple-dark" : "bg-gray-dark3") + " p-2 capitalize cursor-pointer text-xs sm:text-sm"} onClick={(e) => setFilterTab("to-date")}>to date</li> 
                                    </ul>
                                    <div className="col-span-2 mt-2 pr-1">
                                        {(filterTab === "task") &&
                                            <div className="inline-block relative w-full mt-1">
                                                <input type="text" name="taskName" value={filterInputs.taskName} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("task name")} />
                                            </div>
                                        }
                                        {(filterTab === "status") &&
                                            <div className="inline-block relative w-full mt-1">
                                                <input type="text" name="statusName" value={filterInputs.statusName} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("status name")} />
                                            </div>
                                        }
                                        {(filterTab === "from-date") &&
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleFromDateDataFromChild} startDate={null} dateInput={filterInputs.fromDate}/>
                                            </div>
                                        }
                                        {(filterTab === "to-date") &&
                                            <div className="border-black-100 border-2 rounded-lg">
                                                <DatePickerComponent setDataFromChild={handleToDateDataFromChild} startDate={null} dateInput={filterInputs.toDate}/>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="flex items-center justify-between p-2">
                                    <button  onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                    <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                : null
            }
        </div>
    )
}

export default TaskFilterComponent;